import {HistoricalRedemption} from './redemption/historicalRedemption';


export const combineSplitUsageDays = (redemptionHistory: HistoricalRedemption[]): HistoricalRedemption[] => {
  const splitDays = redemptionHistory.filter((redemption) => redemption.redemptionSplitFactor === 2);
  const nonSplitDays = redemptionHistory.filter((redemption) => redemption.redemptionSplitFactor === 1);
  const matchedSplitDays: HistoricalRedemption[] = [];
  splitDays.length && splitDays.forEach((splitDay) => {
    const matchedSplitDay = splitDays.find(
      (day) =>  new Date(splitDay.redeemDate).getDate() === new Date(day.redeemDate).getDate());
    if (matchedSplitDay && splitDay !== matchedSplitDay) {
      matchedSplitDays.push({
        redemptionID: `${splitDay.redemptionID}/${matchedSplitDay.redemptionID}`,
        redemptionTypeId: splitDay.redemptionTypeId,
        redeemDate: splitDay.redeemDate,
        redeemResort: [splitDay.redeemResort, matchedSplitDay.redeemResort].sort().join(' / '),
        redeemLocation: splitDay.redeemLocation,
        redemptionExternalCode: splitDay.redemptionExternalCode,
        redemptionIdReference: splitDay.redemptionIdReference,
        redeemQuantity: splitDay.redeemQuantity,
        fulfillmentSeasonDescription: splitDay.fulfillmentSeasonDescription,
        redemptionSplitFactor: 2,
        modifiedById: splitDay.modifiedById,
      });
    }
  });
  return [...matchedSplitDays, ...nonSplitDays];
}